
export default function Error() {
    return (
        <div style={{textAlign: "center"}}>
            <p style={{fontSize: '2rem', color: '#0b456e'}}>Error occurred !</p>
        </div>
    )
}